import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';
import Hero from './components/Hero';
import LoginForm from './components/LoginForm';

export default function LoginPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />

      <section className="py-16 md:py-24 bg-white">
        <div className="max-w-md mx-auto px-4 md:px-6">
          <div className="text-center mb-8">
            <p className="text-emerald-600 text-sm font-medium tracking-widest uppercase mb-3">
              Valued Clients
            </p>
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-gray-900">
              Client Portal
            </h2>
            <p className="text-gray-600 mt-4 text-base">
              Welcome back. Sign in below to place your wholesale stock orders and manage your
              account with GreenEmbers.
            </p>
          </div>

          <div className="bg-white border border-gray-200 rounded-lg p-6 md:p-8">
            <LoginForm />
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}